import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '~/lib/utils';

const accentBorderVariants = cva(
  'relative overflow-hidden',
  {
    variants: {
      variant: {
        default: 'before:absolute before:inset-0 before:bg-gradient-primary before:opacity-20',
        accent: 'before:absolute before:inset-0 before:bg-gradient-accent before:opacity-20',
        subtle: 'before:absolute before:inset-0 before:bg-gradient-subtle',
      },
      position: {
        top: 'before:h-[2px] before:bottom-auto',
        bottom: 'before:h-[2px] before:top-auto',
        left: 'before:w-[2px] before:right-auto',
        right: 'before:w-[2px] before:left-auto',
        all: 'before:rounded-[inherit]',
      },
    },
    defaultVariants: {
      variant: 'default',
      position: 'top',
    },
  }
);

export interface AccentBorderProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof accentBorderVariants> {
  as?: React.ElementType;
}

const AccentBorder = React.forwardRef<HTMLDivElement, AccentBorderProps>(
  ({ className, variant, position, as: Component = 'div', children, ...props }, ref) => {
    return (
      <Component
        className={cn(accentBorderVariants({ variant, position }), className)}
        ref={ref}
        {...props}
      >
        {children}
      </Component>
    );
  }
);
AccentBorder.displayName = 'AccentBorder';

export { AccentBorder, accentBorderVariants };
